/* ALGEA lens tint data — transcribed from the 2026 catalogue, pages 08–17.

   Source: first transcribed from the 2026-07-28 draft, which is SUPERSEDED. Authority is the
   FINAL catalogue (2026-09-24, sha256 fd025ced…); sun sections re-checked against FINAL
   pp.17–18, photochromic availability overridden by the generated FINAL block below.

   This is reference data, not derived data: the colour gamuts and the index
   restrictions are printed in the catalogue and cannot be computed from the
   price tables, which is why they are transcribed here rather than generated.

   The catalogue states plainly that "Ngjyrat janë ilustruese. Nuancat e sakta
   mund të ndryshojnë sipas indeksit dhe modelit." The swatch hex values below
   are therefore indicative only — they exist so a customer can tell the
   options apart on screen, never to promise an exact shade. The drawer must
   keep saying so, and must keep pointing at the physical samples in store.

   AVAILABILITY IS INDEX-DEPENDENT. Getting this wrong quotes a customer a
   colour that cannot be made in their prescription, so every rule below cites
   the catalogue line it came from. */
window.ALGEA_TINTS = {
  note: "Ngjyrat janë ilustruese. Nuancat e sakta ndryshojnë sipas indeksit dhe modelit — mostrat fizike i keni në dyqan.",

  /* ---------------------------------------------------------- photochromic */
  photochromic: {
    /* Transitions® GEN-S — 9 colours (catalogue p.15). Ruby is the 2025 addition. */
    genS: [
      { key: "grigio",   label: "Grigio (gri)",     hex: "#6b6b6e" },
      { key: "grafite",  label: "Grafite",          hex: "#4a4a4d" },
      { key: "marrone",  label: "Marrone (kafe)",   hex: "#6b4a32" },
      { key: "ambra",    label: "Ambra",            hex: "#c8873a" },
      { key: "verde",    label: "Verde (jeshile)",  hex: "#4a6b52" },
      { key: "smeraldo", label: "Smeraldo",         hex: "#2f6b5a" },
      { key: "zaffiro",  label: "Zaffiro",          hex: "#3a5a8c" },
      { key: "ametista", label: "Ametista",         hex: "#6b4a7a" },
      { key: "ruby",     label: "Ruby ★ (e re 2025)", hex: "#8c3a4a" }
    ],
    /* XTRActive — 3 colours, and the only ones that darken inside a car. */
    xtractive: [
      { key: "grigio",  label: "Grigio (gri)",    hex: "#6b6b6e" },
      { key: "verde",   label: "Verde (jeshile)", hex: "#4a6b52" },
      { key: "marrone", label: "Marrone (kafe)",  hex: "#6b4a32" }
    ],
    /* Only grey and brown exist across every stock line and the high indices. */
    basic: ["grigio", "marrone"],

    /* Rules are evaluated top to bottom; the first match wins. Each carries the
       catalogue sentence it encodes, so a future edit can be checked against
       the page rather than against someone's memory. */
    rules: [
      { brand: "World Vision", colours: "basic",
        src: "p.08 — «Fotokromatike ekonomike. Ngjyrat e disponueshme: vetëm gri dhe kafe.»" },
      { brand: "World Vision", family: /Fotokromatike/i, colours: "basic",
        src: "p.11/12 — «Ngjyrat: vetëm gri dhe kafe.»" },

      { brand: "Ital Lenti", supply: "stock", colours: "basic",
        src: "p.07 — «Ngjyrat Gen-S STOK: vetëm gri & kafe.»" },
      { brand: "Ital Lenti", supply: "rx", index: [1.59, 1.74], colours: "basic",
        src: "p.07 — «1.59 PC & 1.74 — vetëm gri & kafe.»" },
      { brand: "Ital Lenti", supply: "rx", index: [1.50, 1.60, 1.67], colours: "genS",
        src: "p.07 — «Ngjyrat Gen-S RX: 1.50, 1.60 & 1.67 — të gjitha ngjyrat.»" },

      { brand: "Essilor", supply: "stock", index: [1.50], colours: "basic",
        src: "p.08 — «STOK: 1.50 (gri/kafe).»" },
      { brand: "Essilor", supply: "stock", index: [1.60], colours: ["grigio", "marrone", "verde"],
        src: "p.08 — «STOK: 1.60 (gri/kafe/jeshile).»" },
      { brand: "Essilor", index: [1.74], colours: "basic",
        src: "p.08 & p.11 — «1.74 — vetëm gri/kafe.»" },
      { brand: "Essilor", index: [1.50, 1.60, 1.67], colours: "genS",
        src: "p.08 & p.11 — «1.50/1.60/1.67 — të gjitha ngjyrat Gen-S.»" }
    ],
    fallback: "basic"
  },

  /* ------------------------------------------------------------------ sun */
  sun: {
    /* Ital Lenti NuPolar® — polarised, available on any prescription. */
    nupolar: {
      brand: "Ital Lenti", polarised: true,
      label: "NuPolar® — të polarizuara",
      blurb: "Eliminojnë 99.9% shkëlqimin. Disponueshëm për çdo recetë.",
      colours: [
        { key: "green", label: "Green (jeshile)", hex: "#4a6b52" },
        { key: "gray",  label: "Gray (gri)",      hex: "#6b6b6e" },
        { key: "brown", label: "Brown (kafe)",    hex: "#6b4a32" }
      ],
      src: "FINAL p.17 — «NUPOLAR® — POLARIZUARA (3 NGJYRA)»"
    },

    /* Ital Lenti Vista-Sole — tinted, NOT polarised. Density is the filter
       strength: 85% is strong sun, 10% is a light tint. The available
       densities differ per colour, so the grid is stored per colour. */
    vistaSole: {
      brand: "Ital Lenti", polarised: false,
      label: "Vista-Sole — me ngjyrë (jo të polarizuara)",
      blurb: "Zgjidhni ngjyrën dhe përqindjen e ngjyrosjes nga opsionet e kësaj game.",
      colours: [
        { key: "brown",  label: "Brown (kafe)",    hex: "#6b4a32", densities: [85, 70, 50, 30, 10] },
        { key: "gray",   label: "Gray (gri)",      hex: "#6b6b6e", densities: [85, 70, 50, 30, 10] },
        { key: "green",  label: "Green (jeshile)", hex: "#4a6b52", densities: [70, 50, 30] },
        { key: "yellow", label: "Yellow (e verdhë)", hex: "#b8a03a", densities: [50, 30, 10] },
        { key: "pink",   label: "Pink (rozë)",     hex: "#b87a8c", densities: [50, 30, 10] },
        { key: "blu",    label: "Blu",             hex: "#3a5a8c", densities: [50, 30, 10] }
      ],
      src: "FINAL p.17 — «VISTA-SOLE — ME NGJYRË (JO-POLARIZUARA)»"
    },

    /* Specchiatura — an external mirror finish applied over a tint. The
       catalogue names Gray 70% as the optimal base, so the drawer says so
       rather than letting someone pair it badly. */
    mirror: {
      brand: "Ital Lenti",
      label: "Specchiatura — pasqyrim",
      blurb: "Efekt pasqyre në sipërfaqen e jashtme të lentes. Zgjidhni një ngjyrë ose vazhdoni pa pasqyrim.",
      bestOver: { colour: "gray", density: 70 },
      colours: [
        { key: "blu",      label: "Blu",      hex: "#3a5a8c" },
        { key: "rosso",    label: "Rosso",    hex: "#8c3a3a" },
        { key: "verde",    label: "Verde",    hex: "#4a6b52" },
        { key: "oro",      label: "Oro",      hex: "#b8963a" },
        { key: "argento",  label: "Argento",  hex: "#a8a8ac" },
        { key: "bronzo",   label: "Bronzo",   hex: "#8c6b3a" },
        { key: "viola",    label: "Viola",    hex: "#6b4a7a" },
        { key: "rosa",     label: "Rosa",     hex: "#b87a8c" }
      ],
      src: "FINAL p.17 — «SPECCHIATURA — MIRROR (8 NGJYRA)»"
    },

    /* Essilor Xperio® — polarised, on Varilux and single vision. Solid and
       gradual share the same three base colours; Xperio Colors is a separate
       nine-colour range, also offered as a gradual e-mirror. */
    xperio: {
      brand: "Essilor", polarised: true,
      label: "Xperio® — të polarizuara",
      blurb: "7 shtresa polarizuese, mbrojtje UV E-SPF® 50+, eliminon 99.9% shkëlqimin.",
      finishes: [
        { key: "solid",         label: "Solid (Kat.3 / Kat.4)" },
        { key: "gradual",       label: "Gradual (Kat.3)" },
        { key: "colors",        label: "Xperio Colors (solid, Kat.3)" },
        { key: "colors_mirror", label: "Xperio Colors gradual (e-mirror)" }
      ],
      base: [
        { key: "brown",      label: "Brown (kafe)",       hex: "#6b4a32", use: "Peshkim, drejtim mjeti, kontrast i lartë" },
        { key: "grey",       label: "Grey (gri)",         hex: "#6b6b6e", use: "Sport, dritë e fortë, ngjyra natyrale" },
        { key: "grey_green", label: "Grey Green (jeshile)", hex: "#4a6b52", use: "Golf, natyrë, aktivitete të hapura" }
      ],
      colors: [
        { key: "blue_purple", label: "Blue purple", hex: "#5a4a8c" },
        { key: "purple",      label: "Purple",      hex: "#6b4a7a" },
        { key: "blue_sky",    label: "Blue sky",    hex: "#5a8cb8" },
        { key: "blue",        label: "Blue",        hex: "#3a5a8c" },
        { key: "herbal",      label: "Herbal",      hex: "#5a7a4a" },
        { key: "amber",       label: "Amber",       hex: "#b8873a" },
        { key: "charcoal",    label: "Charcoal",    hex: "#4a4a4d" },
        { key: "chocolate",   label: "Chocolate",   hex: "#5a3a2a" },
        { key: "agadir_blue", label: "Agadir Blue", hex: "#2f5a7a" }
      ],
      filtering: "~75–80%",
      src: "FINAL p.18 — «Essilor Xperio® — Xhama të Polarizuar»"
    }
  }
};

/* Resolve which photochromic colours a given lens can actually be made in.
   Rules are ordered most-specific first and the first match wins, so a change
   to one line cannot silently widen another. Anything unmatched falls back to
   grey and brown, which every line offers — erring toward the option that
   certainly exists rather than one that might not. */
window.ALGEA_TINTS.photochromicFor = function (lens) {
  var T = window.ALGEA_TINTS.photochromic;
  function expand(spec) {
    if (spec === "basic") return T.genS.filter(function (c) { return T.basic.indexOf(c.key) !== -1; });
    if (spec === "genS") return T.genS.slice();
    if (Object.prototype.toString.call(spec) === "[object Array]") {
      return T.genS.filter(function (c) { return spec.indexOf(c.key) !== -1; });
    }
    return T.genS.filter(function (c) { return T.basic.indexOf(c.key) !== -1; });
  }
  for (var i = 0; i < T.rules.length; i++) {
    var r = T.rules[i];
    if (r.brand && r.brand !== lens.brand) continue;
    if (r.supply && r.supply !== (lens.stock ? "stock" : "rx")) continue;
    if (r.family && !r.family.test(lens.family || "")) continue;
    if (r.index && r.index.indexOf(Number(lens.index)) === -1) continue;
    return { colours: expand(r.colours), src: r.src };
  }
  return { colours: expand(T.fallback), src: "fallback — gri & kafe ekzistojnë në çdo linjë" };
};

/* XTRActive is the only family that also darkens behind a windscreen, so it is
   offered separately rather than mixed into the GEN-S list. */
window.ALGEA_TINTS.isXtractive = function (lens) {
  return /XTRActive/i.test(lens.family || "");
};

/* ---- FINAL catalogue photochromic technologies (generated; do not edit by hand) ----
   Source: ALGEA Optika_Katalogu i lenteve 2026.pdf (2026-09-24, sha256 fd025ced…), p.21 codes.
   Owner 2026-09-26: Color Touch, XTRActive and XTRActive Polarized are sold as their own
   variants at the Gen S price + 10 EUR; a lens only offers a technology it has a variant slot for. */
(function () {
  var T = window.ALGEA_TINTS;
  var P = {"gens": [{"key": "gr", "code": "GR", "label": "Grey (gri)", "hex": "#6b6b6e"}, {"key": "br", "code": "BR", "label": "Brown (kafe)", "hex": "#6b4a32"}, {"key": "gg", "code": "GG", "label": "Graphite green (gri-jeshile)", "hex": "#4d5a4f"}, {"key": "sap", "code": "SAP", "label": "Sapphire", "hex": "#3a5a8c"}, {"key": "amt", "code": "AMT", "label": "Amethyst", "hex": "#6b4a7a"}, {"key": "amb", "code": "AMB", "label": "Amber", "hex": "#c8873a"}, {"key": "em", "code": "EM", "label": "Emerald", "hex": "#2f6b5a"}, {"key": "rb", "code": "RB", "label": "Ruby", "hex": "#8c3a4a"}], "ct": [{"key": "sap", "code": "SAP", "label": "Sapphire", "hex": "#3a5a8c"}, {"key": "amt", "code": "AMT", "label": "Amethyst", "hex": "#6b4a7a"}, {"key": "amb", "code": "AMB", "label": "Amber", "hex": "#c8873a"}, {"key": "em", "code": "EM", "label": "Emerald", "hex": "#2f6b5a"}, {"key": "rb", "code": "RB", "label": "Ruby", "hex": "#8c3a4a"}], "xa": [{"key": "gr", "code": "GR", "label": "Grey (gri)", "hex": "#6b6b6e"}, {"key": "br", "code": "BR", "label": "Brown (kafe)", "hex": "#6b4a32"}, {"key": "gg", "code": "GG", "label": "Graphite green (gri-jeshile)", "hex": "#4d5a4f"}], "xp": [{"key": "gr", "code": "GR", "label": "Grey (gri)", "hex": "#6b6b6e"}]};
  var R = [{"f":"STOK Fotokromatike (Transitions® GEN-S)","t":"gens","i":[1.5,1.6],"c":["GR","BR"]},{"f":"RX Fotokromatike (Transitions® GEN-S)","t":"gens","i":[1.5,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"RX Fotokromatike (Transitions® GEN-S)","t":"gens","i":[1.59,1.74],"c":["GR","BR"]},{"f":"Monofokale Organike Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Monofokale Organike Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Monofokale Organike Transitions® Gen S™","t":"xa","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG"]},{"f":"Monofokale Organike Transitions® Gen S™","t":"xp","i":[1.5,1.59,1.6,1.67],"c":["GR"]},{"f":"Eyezen® Start Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Eyezen® Start Transitions® Gen S™","t":"gens","i":[1.74],"c":["GR","BR"]},{"f":"Liberty 3.0 — Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Liberty 3.0 — Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Liberty 3.0 — Transitions® Gen S™","t":"xa","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG"]},{"f":"Liberty 3.0 — Transitions® Gen S™","t":"xp","i":[1.5,1.59,1.6,1.67],"c":["GR"]},{"f":"Comfort Max — Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Comfort Max — Transitions® Gen S™","t":"gens","i":[1.74],"c":["GR","BR"]},{"f":"Comfort Max — Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Comfort Max — Transitions® Gen S™","t":"xa","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG"]},{"f":"Comfort Max — Transitions® Gen S™","t":"xp","i":[1.5,1.59,1.6,1.67],"c":["GR"]},{"f":"Physio extensee™ — Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Physio extensee™ — Transitions® Gen S™","t":"gens","i":[1.74],"c":["GR","BR"]},{"f":"Physio extensee™ — Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Physio extensee™ — Transitions® Gen S™","t":"xa","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG"]},{"f":"Physio extensee™ — Transitions® Gen S™","t":"xp","i":[1.5,1.59,1.6,1.67],"c":["GR"]},{"f":"XR Design — Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"XR Design — Transitions® Gen S™","t":"gens","i":[1.74],"c":["GR","BR"]},{"f":"XR Design — Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"XR Pro — Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"XR Pro — Transitions® Gen S™","t":"gens","i":[1.74],"c":["GR","BR"]},{"f":"XR Pro — Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Immersia™ Transitions® Gen S™","t":"gens","i":[1.5,1.59,1.6,1.67],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Immersia™ Transitions® Gen S™","t":"gens","i":[1.74],"c":["GR","BR"]},{"f":"Immersia™ Transitions® Gen S™","t":"ct","i":[1.5,1.59,1.6,1.67],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Streetlife Transitions® XTRActive®","t":"xa","i":[1.5,1.6,1.67],"c":["GR","BR","GG"]},{"f":"Streetlife Transitions® XTRActive®","t":"xp","i":[1.5,1.6,1.67],"c":["GR"]},{"f":"Myopica Transitions®","t":"gens","i":[1.5,1.6],"c":["GR","BR"]},{"f":"Monofokale Kids Transitions®","t":"gens","i":[1.5,1.6],"c":["GR","BR"]},{"f":"Eyezen® Kids Transitions® Gen S™","t":"gens","i":[1.5,1.6],"c":["GR","BR","GG","SAP","AMT","AMB","EM","RB"]},{"f":"Eyezen® Kids Transitions® Gen S™","t":"ct","i":[1.5,1.6],"c":["SAP","AMT","AMB","EM","RB"]},{"f":"Monofokale Fotokromatike","t":"gens","i":[1.56,1.6,1.67,1.71,1.74],"c":["GR","BR"],"s":"Katalogu 2026 (FINAL) · fotokromatike"},{"f":"Progresive Fotokromatike","t":"gens","i":[1.56,1.6,1.67,1.71,1.74],"c":["GR","BR"],"s":"Katalogu 2026 (FINAL) · fotokromatike"},{"f":"Bifokale Transitions®","t":"gens","i":[1.5],"c":["BR"],"s":"Katalogu 2026 (FINAL) · Transitions®"},{"f":"Bifokale Fotokromatike (Ekonomike)","t":"gens","i":[1.56,1.6,1.67,1.71,1.74],"c":["GR","BR"],"s":"Katalogu 2026 (FINAL) · fotokromatike"},{"f":"Sky Comfort — Transitions® GEN-S / XTRActive","t":"gens","i":[1.5,1.6,1.67],"c":["GR","GG","BR"],"s":"Ital Lenti — Listino Pubblico (fq. 54)"},{"f":"Sky Comfort — Transitions® GEN-S / XTRActive","t":"xa","i":[1.5,1.6,1.67],"c":["GR","GG","BR"],"s":"Ital Lenti — Listino Pubblico (fq. 54)"},{"f":"Premium HV — Transitions® GEN-S / XTRActive","t":"gens","i":[1.5,1.6,1.67],"c":["GR","GG","BR","SAP","AMT","AMB","EM","RB"],"s":"Ital Lenti — Listino Pubblico (fq. 50)"},{"f":"Premium HV — Transitions® GEN-S / XTRActive","t":"gens","i":[1.74],"c":["GR","BR"],"s":"Ital Lenti — Listino Pubblico (fq. 50)"},{"f":"Premium HV — Transitions® GEN-S / XTRActive","t":"xa","i":[1.5,1.6,1.67],"c":["GR","GG","BR"],"s":"Ital Lenti — Listino Pubblico (fq. 50)"},{"f":"Twice Easy — Transitions® GEN-S / XTRActive","t":"gens","i":[1.5,1.6,1.67,1.74],"c":["GR","BR"],"s":"Ital Lenti — Listino Pubblico (fq. 38)"},{"f":"Twice Easy — Transitions® GEN-S / XTRActive","t":"xa","i":[1.5,1.6,1.67],"c":["GR","BR"],"s":"Ital Lenti — Listino Pubblico (fq. 38)"}];
  var LABEL = {"gens": "Transitions® Gen S™", "ct": "Transitions® Color Touch™", "xa": "Transitions® XTRActive®", "xp": "Transitions® XTRActive® Polarized™"};
  var legacyFor = T.photochromicFor;
  function rulesFor(lens, tech) {
    return R.filter(function (r) {
      return r.f === lens.family && r.t === tech && r.i.indexOf(Number(lens.index)) !== -1;
    });
  }
  function pick(palette, codes) {
    return Array.isArray(codes) ? palette.filter(function (c) { return codes.indexOf(c.code) !== -1; }) : [];
  }
  /* Owner 2026-09-30: one short line under each technology tile. FINAL pp.20-21: Gen S fully clear
     indoors; XTRActive (and Polarized) keep a slight tint indoors and darken partly in the car;
     Color Touch keeps a slight tint indoors and darkens outdoors "like Gen S". */
  T.techNotes = {
    gens: "E kthjellët brenda, e errët jashtë, nuk errësohet në makinë.",
    ct: "Nuancë e lehtë brenda, e errët jashtë, nuk errësohet në makinë.",
    xa: "Nuancë e lehtë brenda, e errët jashtë dhe pjesërisht në makinë.",
    xp: "Nuancë e lehtë brenda, e errët jashtë dhe pjesërisht në makinë.",
    xtractive: "Nuancë e lehtë brenda, e errët jashtë dhe pjesërisht në makinë."
  };
  T.photochromic.final = P;
  T.techOptions = function (lens) {
    if (!lens || !lens.tech || !rulesFor(lens, "gens").length) return [];
    var out = [{ key: "gens", label: LABEL.gens, hex: "#8a8a8d" }];
    ["ct", "xa", "xp"].forEach(function (k) {
      if (lens.tech[k] && rulesFor(lens, k).length) out.push({ key: k, label: LABEL[k], hex: "#5a5a5d" });
    });
    return out.length > 1 ? out : [];
  };
  T.techColours = function (lens, tech) {
    if (tech && tech !== "gens" && P[tech]) {
      var tr = rulesFor(lens, tech)[0];
      return pick(P[tech], tr && tr.c);
    }
    return T.photochromicFor(lens).colours;
  };
  T.photochromicFor = function (lens) {
    var r = rulesFor(lens, "gens")[0];
    if (r) return { colours: pick(P.gens, r.c), src: r.c ? (r.s || "Katalogu 2026 (FINAL) · Transitions® Gen S™") : "Ngjyrat për këtë kombinim kërkojnë konfirmim. Na kontaktoni.", status: r.c ? "supported" : "unconfirmed" };
    var xa = rulesFor(lens, "xa")[0];
    if (xa) return { colours: pick(P.xa, xa.c), src: xa.c ? "Katalogu 2026 (FINAL) · XTRActive®" : "Ngjyrat për këtë kombinim kërkojnë konfirmim. Na kontaktoni.", status: xa.c ? "supported" : "unconfirmed" };
    return legacyFor(lens);
  };
})();

/* W34: translate labels, blurbs and notes once at load (keys, codes and families stay Albanian). */
(function () {
  var T = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };
  var FIELDS = { label: 1, blurb: 1, note: 1, use: 1 };
  (function walk(o) {
    if (!o || typeof o !== "object") return;
    Object.keys(o).forEach(function (k) {
      var v = o[k];
      if (typeof v === "string" && FIELDS[k]) o[k] = T(v);
      else if (v && typeof v === "object" && !(v instanceof RegExp)) walk(v);
    });
  })(window.ALGEA_TINTS);
  var N = window.ALGEA_TINTS.techNotes;
  if (N) Object.keys(N).forEach(function (k) { N[k] = T(N[k]); });
})();
